import {Product} from "../types/types";

export const Categories = [
    {
    name: '모델링',
    path: '/products/modeling',
    subcategories: [
      { name: '아이템/도구', path: '/products/modeling?subcategory=아이템/도구' },
      { name: '가구', path: '/products/modeling?subcategory=가구' },
      { name: '커스텀블럭', path: '/products/modeling?subcategory=커스텀블럭' },
    ],
  },
  {
    name: '건축',
    path: '/products/building',
    subcategories: [
      { name: '스폰/허브', path: '/products/building?subcategory=스폰/허브' },
      { name: '던전', path: '/products/building?subcategory=던전' },
      { name: '맵', path: '/products/building?subcategory=맵' },
      { name: '스키마틱', path: '/products/building?subcategory=스키마틱' },
    ],
  },
  {
    name: '엔티티',
    path: '/products/entity',
    subcategories: [
      { name: '보스', path: '/products/entity?subcategory=보스' },
      { name: '몹/동물', path: '/products/entity?subcategory=몹/동물' },
      { name: '펫', path: '/products/entity?subcategory=펫' },
      { name: '탈것', path: '/products/entity?subcategory=탈것' },
      { name: '상자', path: '/products/entity?subcategory=상자' },
    ],
  },
  {
    name: '픽셀',
    path: '/products/pixel',
    subcategories: [
      { name: '채팅관련', path: '/products/pixel?subcategory=채팅관련' },
      { name: '아이콘, 스프라이트', path: '/products/pixel?subcategory=아이콘, 스프라이트' },
      { name: '인게임 GUI', path: '/products/pixel?subcategory=인게임 GUI' },
      { name: 'HUD', path: '/products/pixel?subcategory=HUD' },
      { name: '쉐이더', path: '/products/pixel?subcategory=쉐이더' },
      { name: '스킨', path: '/products/pixel?subcategory=스킨' },
    ],
  },
  {
    name: '무료',
    path: '/products/free',
    subcategories: [],
  },
  {
    name: '스크립트',
    path: '/products/script',
    subcategories: [],
  },
  {
    name: '스킬',
    path: '/products/skill',
    subcategories: [],
  },
  {
    name: '스킨',
    path: '/products/skin',
    subcategories: [],
  },
  {
    name: '플러그인',
    path: '/products/plugin',
    subcategories: [],
  },
];

export const allProducts: Product[] = [
  {
    id: 1,
    category: "example",
    date: Date.now(),
    star: 5,
    review: 10,
    nickname: "user1",
    name: "상품 이름",
    price: 10000,
    originalPrice: 15000,
    discount: "33%",
    isDiscounted: true,
    image: "/path/to/image.png",
    additionalImages: ["/path/to/another-image.png"],
    description: "상품 설명",
    usageInstructions: "사용 방법",
    introduction: "제작자 정보",
    models: [{ modelUrl: "/path/to/model.glb", modelName: "모델 이름" }],
    skins: [{ skinUrl: "/path/to/skin.png", skinName: "스킨 이름" }],
    profileImageUrl:"T"
  },
];

export const Services_ARR = [
  {
    id: 1,
    no: '01',
    title: '고객센터 질문 1',
    answer: '질문 1에 대한 답변입니다.',
  },
  {
    id: 2,
    no: '02',
    title: '고객센터 질문 2',
    answer: '질문 2에 대한 답변입니다.',
  },
  {
    id: 3,
    no: '03',
    title: '고객센터 질문 3',
    answer: '질문 3에 대한 답변입니다.',
  },
  {
    id: 4,
    no: '04',
    title: '고객센터 질문 4',
    answer: '질문 4에 대한 답변입니다.',
  },
  {
    id: 5,
    no: '05',
    title: '고객센터 질문 5',
    answer: '질문 5에 대한 답변입니다.',
  },
  {
    id: 6,
    no: '06',
    title: '고객센터 질문 6',
    answer: '질문 6에 대한 답변입니다.',
  },
  {
    id: 7,
    no: '07',
    title: '고객센터 질문 7',
    answer: '질문 7에 대한 답변입니다.',
  },
  {
    id: 8,
    no: '08',
    title: '고객센터 질문 8',
    answer: '질문 8에 대한 답변입니다.',
  },
  {
    id: 9,
    no: '09',
    title: '고객센터 질문 9',
    answer: '질문 9에 대한 답변입니다.',
  },
  {
    id: 10,
    no: '10',
    title: '고객센터 질문 10',
    answer: '질문 10에 대한 답변입니다.',
  },
];